export function generateRandomString(length: number) {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

export function sanitizeToSlug(value: string): string {
  return value
    .toLowerCase() // force lowercase
    .replace(/\s+/g, '-') // spaces -> hyphens
    .replace(/[^a-z0-9-]/g, ''); // strip anything not a-z, number, or hyphen
}

export function titleFormatter(title: string) {
  if (title !== '') {
    return `${title} | Tidy Ranking`;
  }

  return 'Tidy Ranking';
}
